import * as React from "react"
import Svg, { Path } from "react-native-svg"

const RestaurantIcon = (props) => (
    <Svg
        width={props.size}
        height={props.size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.213.983c0-.405.312-.733.697-.733h4.448c.385 0 .697.328.697.733 0 .405-.312.734-.697.734H8.91c-.385 0-.697-.329-.697-.734Z"
            fill={props.color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.171.25c.386 0 .698.328.698.733v2.709c3.868.22 6.347 2.275 7.884 4.708 1.604 2.54 2.18 5.482 2.342 7.177l.076.806h-22l.077-.806C.41 13.882.986 10.94 2.59 8.4c1.536-2.433 4.016-4.487 7.884-4.708V.983c0-.405.312-.733.697-.733ZM1.736 14.917h18.871c-.238-1.583-.807-3.791-2.016-5.706-1.409-2.23-3.685-4.072-7.42-4.072-3.734 0-6.01 1.841-7.42 4.072-1.208 1.915-1.778 4.123-2.015 5.706ZM.245 21.517c0-.405.312-.734.697-.734h20.459c.385 0 .697.329.697.734 0 .405-.312.733-.697.733H.942c-.385 0-.697-.328-.697-.733Z"
            fill={props.color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.626 7.586c.127-.382.524-.584.888-.45 1.067.39 2.744 1.678 3.535 3.852.138.378-.042.802-.402.947-.36.145-.763-.045-.9-.423-.633-1.737-1.98-2.73-2.692-2.992-.364-.133-.556-.551-.429-.934Z"
            fill={props.color}
        />
    </Svg>
)

export default RestaurantIcon
